import { SxType } from '@/shared/constants';
import { Grid, Paper } from '@mui/material';

export type CustomPaperBoxProps = {
  children?: React.ReactNode;
  sxPaper?: SxType;
};

const CustomPaperBox: React.FC<CustomPaperBoxProps> = ({
  children,
  sxPaper,
}) => {
  return (
    <Paper
      className="paper-producto"
      sx={{
        minWidth: '100%',
        mb: 3,
        ...sxPaper,
      }}
    >
      <Grid item container spacing={3} justifyContent="center">
        {children}
      </Grid>
    </Paper>
  );
};

export default CustomPaperBox;
